import {Injectable} from '@angular/core';
import {DcpDataService} from '../dcp-data.service';
import {EddlAdobeTrackingData} from './models/eddl-adobe-tracking-data';
import {CxEvent, EventService} from '@spartacus/core';
import {EddlSearchInitiatedEvent} from './events/eddl-search-initiated-event';
import {EddlSearchNoResultsEvent} from './events/eddl-search-no-results-event';
import {DcpEddlSearchTrackingService} from './dcp-eddl-search-tracking.service';
import {UntilDestroy} from '@ngneat/until-destroy';
import {EddlSearchResultsClickEvent} from './events/eddl-search-results-click-event';

export const EDDL_SEARCH_EVENT_NAME = 'search';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class DcpEddlSearchDataService extends DcpDataService<EddlAdobeTrackingData> {

  constructor(
    protected searchTrackingService: DcpEddlSearchTrackingService,
    protected eventService: EventService,
  ) {
    super();
  }

  fillData(
    event: EddlSearchInitiatedEvent | EddlSearchNoResultsEvent | EddlSearchResultsClickEvent,
    data?: EddlAdobeTrackingData): EddlAdobeTrackingData {
    if (!data) {
      data = {};
    }
    if (!data.search) {
      data.search = {};
    }

    data.search.term = this.searchTrackingService.getSearchTerm();
    const searchType = this.searchTrackingService.getSearchType();

    if (event instanceof EddlSearchInitiatedEvent) {
      data.event = EDDL_SEARCH_EVENT_NAME;
      data.search.location = this.getSearchLocation(searchType);
    }
    if (event instanceof EddlSearchNoResultsEvent) {
      data.event = 'searchNoResults';
    }
    if (event instanceof EddlSearchResultsClickEvent) {
      data.event = 'searchClick';
      const pageNumber = this.searchTrackingService.getPageNumber();
      const product = this.searchTrackingService.getProductClicked();

      data.search.clickRank = this.searchTrackingService.getClickRank();
      data.search.clickURL = window.location.href;
      data.search.clickTitle = product.name;

      data.search.location = this.getSearchLocation(searchType);
      if (searchType !== 'keyword search') {
        data.search.clickCategory = searchType;
      }

      if (pageNumber > 0) {
        data.search.pageNumber = pageNumber;
      }
    }
    return data;
  }

  getData(event: CxEvent): EddlAdobeTrackingData {
    if (!(event instanceof EddlSearchInitiatedEvent || event instanceof EddlSearchNoResultsEvent
      || event instanceof EddlSearchResultsClickEvent)) {
      return undefined;
    }

    return this.fillData(event);
  }

  private getSearchLocation(searchType: string): 'KSD' | 'SRP' {
    return searchType === 'solution suggestions' ? 'KSD' : 'SRP';
  }
}

